import { Component } from '@theme/component';
const key = 'zoobi-saved-products';
const read = () => { try { const value = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(value) ? value.filter(x => x && typeof x.id === 'string' && typeof x.url === 'string') : []; } catch { return []; } };
/** Browser-local saved products, no customer data or external service. */
class ZoobiSaved extends Component {
  #controller;
  #observer;
  #noticeTimer;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort(); this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const button = target.closest('[data-zoobi-save]');
      if (!button) return;
      event.preventDefault(); event.stopPropagation();
      let items = read();
      const id = button.dataset.zoobiSave;
      if (items.some(x => x.id === id)) items = items.filter(x => x.id !== id);
      else items.push({ id, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image });
      try { localStorage.setItem(key, JSON.stringify(items)); } catch { this.querySelector('[data-saved-status]').textContent = this.dataset.storageError; return; }
      this.#render();
      this.#announce(items.some(x => x.id === id) ? this.dataset.added : this.dataset.removed);
    }, { signal });
    this.addEventListener('click', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const dialog = this.querySelector('dialog');
      if (target.closest('[data-open-saved]')) { this.#render(); dialog.showModal(); }
      if (target.closest('[data-close-saved]')) { dialog.close(); this.querySelector('[data-open-saved]').focus(); }
    }, { signal });
    window.addEventListener('storage', () => this.#render(), { signal });
    this.#observer?.disconnect();
    this.#observer = new MutationObserver(() => this.#sync());
    this.#observer.observe(document.body, { childList: true, subtree: true });
    this.#render();
  }
  #announce(message) {
    let notice = this.notice;
    if (!notice) {
      notice = document.createElement('div');
      notice.dataset.wishlistNotice = '';
      notice.className = 'zhd__wishlist-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      document.body.append(notice);
      this.notice = notice;
    }
    notice = this.notice || notice;
    clearTimeout(this.#noticeTimer);
    notice.textContent = message;
    notice.hidden = false;
    this.#noticeTimer = setTimeout(() => { notice.hidden = true; }, 3000);
  }
  #sync() {
    const items = read();
    for (const b of document.querySelectorAll('[data-zoobi-save]')) b.setAttribute('aria-pressed', String(items.some(x => x.id === b.dataset.zoobiSave)));
  }
  #render() {
    const items = read(); this.querySelector('[data-saved-count]').textContent = items.length;
    const list = this.querySelector('[data-saved-list]'); list.replaceChildren();
    if (!items.length) { const p = document.createElement('p'); p.textContent = this.dataset.empty; list.append(p); }
    for (const item of items) {
      const row = document.createElement('div'); row.className = 'zhd__saved-row';
      const link = document.createElement('a');
      const url = new URL(item.url, location.origin); if (url.origin !== location.origin) continue;
      link.href = url.href; link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.zoobiSave = item.id; remove.textContent = this.dataset.remove;
      row.append(link, remove); list.append(row);
    }
    this.#sync();
  }
  disconnectedCallback() { clearTimeout(this.#noticeTimer); this.notice?.remove(); this.#controller?.abort(); this.#observer?.disconnect(); super.disconnectedCallback(); }
}
if (!customElements.get('zoobi-saved')) customElements.define('zoobi-saved', ZoobiSaved);
